module.exports = __webpack_public_path__ + "img/quest_selector.2ff0884c.png";